import {Component, computed, inject, InjectionToken, input} from '@angular/core';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';

/**
 * App-level defaults for {@link PopoverIconComponent}. Provide this token (e.g. in an app module)
 * to apply a popover CSS class to every popover-icon in that app without setting it on each usage.
 * A per-instance `popoverClass` input still wins over this default.
 */
export const POPOVER_ICON_DEFAULTS = new InjectionToken<{popoverClass?: string}>(
    'POPOVER_ICON_DEFAULTS',
);

@Component({
    selector: 'app-popover-icon',
    standalone: true,
    imports: [NgbPopover],
    template: `<i
        [class]="customClass()"
        [autoClose]="'outside'"
        container="body"
        style="cursor: pointer"
        [popoverTitle]="popoverTitle()"
        [popoverClass]="resolvedPopoverClass()"
        [ngbPopover]="popover()"></i>`,
})
export class PopoverIconComponent {
    private readonly defaults = inject(POPOVER_ICON_DEFAULTS, {optional: true});

    popover = input.required<string>();
    popoverTitle = input<string>();
    customClass = input<string>('bi bi-info-circle');
    popoverClass = input<string>();

    readonly resolvedPopoverClass = computed(
        () => this.popoverClass() ?? this.defaults?.popoverClass ?? '',
    );
}
